import React from 'react';

const Rank = () => {
  return (
   <div>
     <div className='white f3'>
       {'Hey User, Your current rank is 1#'}
     </div>
   </div>
    );
}

export default Rank;